export default {
  'common': {
    'add': '더하다',
    'cancel': '취소',
    'description': '기술',
    'delete': '지우다',
    'title': '표제',
    'save': '저장',
    'faq': '자주하는 질문',
    'contact': '문의하기',
    'tos': '서비스 약관',
    'policy': '개인 정보 정책'
  },
  'board': {
    'titlePlaceholder': '이 카드의 제목을 입력하세요.',
    'deleteDescription': '이 카드를 삭제 하시겠습니까?',
    'editCard': '카드 수정',
    'deleteCard': '카드 삭제',
    'state': {
      'TODO': '할 것',
      'INPROGRESS': '진행중',
      'TESTING': '테스트',
      'DONE': '끝난'
    }
  },
  'chat': {
    'online': '온라인 사용자 ({count})',
    'addChannel': '채널 추가',
    'channel': '채널 | 채널',
    'message': '메시지'
  },
  'email': {
    'compose': '이메일을 쓰다',
    'send': '보내다',
    'subject': '제목',
    'labels': '라벨',
    'emptyList': '빈 이메일 목록',
    'inbox': '받은 편지함',
    'sent': '보냄',
    'drafts': '체커',
    'starred': '별표',
    'trash': '폐물',
    'work': '작업',
    'invoice': '송장'
  },
  'todo': {
    'addTask': '작업 추가',
    'tasks': '과제',
    'completed': '완료',
    'labels': '라벨'
  },
  'dashboard': {
    'activity': '활동',
    'weeklySales': '주간 판매',
    'sales': '매상',
    'recentOrders': '최근 주문들',
    'sources': '트래픽 소스',
    'lastweek': '지난주 대비',
    'orders': '명령',
    'customers': '고객',
    'tickets': '지원 티켓',
    'viewReport': '보고서보기'
  },
  'usermenu': {
    'profile': '프로필',
    'signin': '로그인',
    'dashboard': '계기반',
    'signout': '로그 아웃'
  },
  'error': {
    'notfound': '페이지를 찾을 수 없음',
    'other': '오류가 발생했습니다'
  },
  'check': {
    'title': '새 비밀번호 설정',
    'backtosign': '로그인으로 돌아 가기',
    'newpassword': '새 비밀번호',
    'button': '새 비밀번호 설정 및 로그인',
    'error': '작업 링크가 잘못되었습니다.',
    'verifylink': '링크 확인 중 ...',
    'verifyemail': '이메일 주소 확인 중 ...',
    'emailverified': '이메일이 확인되었습니다! 리디렉션 중 ...'
  },
  'forgot': {
    'title': '비밀번호를 잊으 셨나요?',
    'subtitle': '계정 이메일 주소를 입력하면 비밀번호를 재설정 할 수있는 링크를 보내드립니다.',
    'email': '이메일',
    'button': '비밀번호 재설정 요청',
    'backtosign': '로그인으로 돌아 가기'
  },
  'login': {
    'title': '로그인',
    'email': '이메일',
    'password': '암호',
    'button': '로그인',
    'orsign': '또는 다음으로 로그인',
    'forgot': '비밀번호를 잊으 셨나요?',
    'noaccount': '계정이 없으십니까?',
    'create': '여기에서 생성',
    'error': '이메일 / 비밀번호 조합이 잘못되었습니다.'
  },
  'register': {
    'title': '계정 생성',
    'name': '성명',
    'email': '이메일',
    'password': '암호',
    'button': '계정 생성',
    'orsign': '또는 가입',
    'agree': '가입하면 다음에 동의하게됩니다.',
    'account': '이미 계정이 있습니까?',
    'signin': '로그인'
  },
  'utility': {
    'maintenance': '유지 보수 중'
  },
  'faq': {
    'call': '다른 질문이 있습니까? 연락주세요'
  },
  'ecommerce': {
    'products': '제품',
    'filters': '필터',
    'collections': '컬렉션',
    'priceRange': '가격 범위',
    'customerReviews': '소비자 평가',
    'up': '이상',
    'brand': '상표',
    'search': '제품 검색',
    'results': '결과 ({0} / {1})',
    'orders': '명령',
    'shipping': '배송',
    'freeShipping': '무료 배송',
    'inStock': '재고',
    'quantity': '수량',
    'addToCart': '장바구니에 담기',
    'buyNow': '지금 구매',
    'price': '가격',
    'about': '이 항목에 대해',
    'description': '기술',
    'reviews': '리뷰',
    'details': '제품 세부 정보',
    'cart': '카트',
    'summary': '주문 요약',
    'total': '합계',
    'discount': '할인',
    'subtotal': '소계',
    'continue': '쇼핑을 계속',
    'checkout': '점검'
  },
  'menu': {
    'search': '검색 (초점하려면 \'ctrl + /\'누르기)',
    'dashboard': '계기반',
    'logout': '로그 아웃',
    'profile': '프로필',
    'blank': '빈 페이지',
    'pages': '페이지',
    'others': '기타',
    'email': '이메일',
    'chat': '잡담',
    'todo': '할 것',
    'board': '태스크 보드',
    'users': '사용자',
    'usersList': '명부',
    'usersEdit': '편집하다',
    'ecommerce': '전자 상거래',
    'ecommerceList': '제품',
    'ecommerceProductDetails': '제품 세부 정보',
    'ecommerceOrders': '명령',
    'ecommerceCart': '카트',
    'auth': '인증 페이지',
    'authLogin': '로그인 / 로그인',
    'authRegister': '가입 / 등록',
    'authVerify': '이메일 확인',
    'authForgot': '비밀번호를 잊으 셨나요',
    'authReset': '암호를 재설정',
    'errorPages': '오류 페이지',
    'errorNotFound': '찾을 수 없음 / 404',
    'errorUnexpected': '예상치 못한 / 500',
    'utilityPages': '유틸리티 페이지',
    'utilityMaintenance': '유지',
    'utilitySoon': '곧 출시',
    'utilityHelp': 'FAQ / 도움말',
    'levels': '메뉴 수준',
    'disabled': '메뉴 비활성화',
    'docs': '선적 서류 비치',
    'feedback': '피드백',
    'support': '지원하다',
    'landingPage': '방문 페이지',
    'pricingPage': '가격 페이지'
  },
  '$vuetify': {
    'badge': '배지',
    'close': '닫기',
    'dataIterator': {
      'noResultsText': '일치하는 기록이 없습니다.',
      'loadingText': '항목로드 중 ...'
    },
    'dataTable': {
      'itemsPerPageText': '페이지 당 행 :',
      'ariaLabel': {
        'sortDescending': '내림차순 정렬.',
        'sortAscending': '오름차순 정렬.',
        'sortNone': '정렬되지 않았습니다.',
        'activateNone': '정렬을 제거하려면 활성화하세요.',
        'activateDescending': '내림차순으로 정렬하려면 활성화하십시오.',
        'activateAscending': '오름차순으로 정렬하려면 활성화하십시오.'
      },
      'sortBy': '정렬 기준'
    },
    'dataFooter': {
      'itemsPerPageText': '페이지 당 항목:',
      'itemsPerPageAll': '모두',
      'nextPage': '다음 페이지',
      'prevPage': '이전 페이지',
      'firstPage': '첫 페이지',
      'lastPage': '마지막 페이지',
      'pageText': '{2} 개 중 {0}-{1}'
    },
    'datePicker': {
      'itemsSelected': '{0} 선택됨',
      'nextMonthAriaLabel': '다음 달',
      'nextYearAriaLabel': '내년',
      'prevMonthAriaLabel': '지난달',
      'prevYearAriaLabel': '전년도'
    },
    'noDataText': '자료 없음',
    'carousel': {
      'prev': '이전 비주얼',
      'next': '다음 영상',
      'ariaLabel': {
        'delimiter': '{1} 개 중 {0} 슬라이드'
      }
    },
    'calendar': {
      'moreEvents': '{0} 더보기'
    },
    'fileInput': {
      'counter': '{0} 파일',
      'counterSize': '{0} 개 파일 (총 {1} 개)'
    },
    'timePicker': {
      'am': 'AM',
      'pm': 'PM'
    },
    'pagination': {
      'ariaLabel': {
        'wrapper': '페이지 매김 탐색',
        'next': '다음 페이지',
        'previous': '이전 페이지',
        'page': '{0} 페이지로 이동',
        'currentPage': '현재 페이지, 페이지 {0}'
      }
    }
  }
}